<template>
  <div>
    <qx-card title="后服产品" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.relId"
      busiCode="400001"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  siteDetail, // 获取详情
  servicerDetail,
} from 'api/service';
import {
  getFileUrl,
  approveItemInfo,
} from 'api';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      serviceType: '',
      serviceUserId: '',
      productId: '',
      loading: false,
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'productName',
                label: '产品名称',
              },
              {
                prop: 'address',
                label: '详细地址',
              },
              {
                prop: 'serviceCall',
                label: '服务电话',
              },
              {
                prop: 'stateName',
                label: '产品状态',
              },
              {
                prop: 'oilCardTypeName',
                label: '油站类型',
              },
              {
                prop: 'locationTypeName',
                label: '所属位置',
              },
              {
                prop: 'introduce',
                label: '产品简介',
              },
              {
                prop: 'productPicUrl',
                label: '油站图片',
                type: 'img',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        merchant: {
          label: '服务商信息',
          tableData: {
            title: [
              {
                prop: 'loginAcct',
                label: '手机账号',
              },
              {
                prop: 'serviceName',
                label: '公司名称',
              },
              {
                prop: 'linkman',
                label: '联系人',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        // settlement: {
        //   label: '结算价',
        //   tableData: {
        //     title: [
        //       {
        //         prop: 'settlementTypeName',
        //         label: '结算类型',
        //       },
        //       {
        //         prop: 'floatBalanceBill',
        //         label: '浮动价（元/升）',
        //       },
        //       {
        //         prop: 'fixedBalanceBill',
        //         label: '固定价（元/升）',
        //       },
        //     ],
        //     data: {

        //     },
        //     approveData: {

        //     },
        //   },
        // },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/service/site/self/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await siteDetail({
        serviceType: this.serviceType || this.$route.query.serviceType,
        productId: this.productId || this.$route.query.id,
        serviceUserId: this.serviceUserId || this.$route.query.serviceUserId,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        if (detailRes.productData.productPicId) { // 油毡图片
          const imgRes = await getFileUrl({
            flowIds: detailRes.productData.productPicId,
          });
          detailRes.productData.productPicUrl = imgRes.items[0].fullPath;
        }
        const serverRes = await servicerDetail({ // 服务商信息
          serviceUserId: detailRes.productData.serviceUserId,
        });
        detailRes.productData = {
          ...detailRes.productData,
          ...serverRes.serviceData,
        };
        // if (detailRes.productData.floatBalanceBill) { // 浮动价结算
        //   detailRes.productData.settlementTypeName = '浮动价结算';
        // } else if (detailRes.productData.fixedBalanceBill) { // 固定价结算
        //   detailRes.productData.settlementTypeName = '固定价结算';
        // } else if (detailRes.productData.localeBalanceState) { // 现场价
        //   detailRes.productData.settlementTypeName = '现场价';
        // } else {
        //   detailRes.productData.settlementTypeName = '浮动价结算';
        // }
        this.detailData.base.tableData.data = detailRes.productData;
        this.detailData.merchant.tableData.data = detailRes.productData;
        // this.detailData.settlement.tableData.data = detailRes.productData;
        if (this.$route.query.type || this.id) {
          if (!detailRes.productDataVer) {
            detailRes.productDataVer = {};
          }
          if (detailRes.productDataVer.productPicId) { // 油毡图片
            const imgRes = await getFileUrl({
              flowIds: detailRes.productDataVer.productPicId,
            });
            detailRes.productDataVer.productPicUrl = imgRes.items[0].fullPath;
          }
          // if (detailRes.productDataVer.floatBalanceBill) { // 浮动价结算
          //   detailRes.productDataVer.settlementTypeName = '浮动价结算';
          // } else if (detailRes.productDataVer.fixedBalanceBill) { // 固定价结算
          //   detailRes.productDataVer.settlementTypeName = '固定价结算';
          // } else if (detailRes.productDataVer.localeBalanceState) { // 现场价
          //   detailRes.productDataVer.settlementTypeName = '现场价';
          // } else {
          //   detailRes.productDataVer.settlementTypeName = '浮动价结算';
          // }
          this.detailData.base.tableData.approveData = detailRes.productDataVer;
          this.detailData.merchant.tableData.approveData = detailRes.productDataVer;
          // this.detailData.settlement.tableData.approveData = detailRes.productDataVer;
        }
      }
    },
  },
  async created () {
    if (this.id) {
      const res = await approveItemInfo({
        busiId: this.id,
        busiCode: 400001,
      });
      this.serviceType = res.serviceType;
      this.serviceUserId = res.serviceUserId;
      this.productId = res.productId;
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
